/* ============================================================
   HollowMade - Comportements CRO
   Aucune dépendance. Tout est optionnel : chaque module ne fait
   rien si son markup n'est pas présent sur la page.
   ============================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var JOURS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  /* ---- jours ouvrés ---------------------------------------- */
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0 && d.getDay() !== 6) n--;
    }
    return d;
  }
  function frDate(d, withDay) {
    return (withDay ? JOURS[d.getDay()] + ' ' : '') + d.getDate() + ' ' + MOIS[d.getMonth()];
  }

  /* ==========================================================
     1. Reveal au scroll
     ========================================================== */
  function initReveal() {
    var els = $$('.hm-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ==========================================================
     2. Compteurs animés + barres d'avis
     ========================================================== */
  // format français : virgule décimale et espace fine insécable pour les milliers
  function fr(n, dec) {
    var parts = n.toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join(',');
  }

  function animateNumber(el) {
    var target = parseFloat(el.dataset.to || '0');
    var dec = parseInt(el.dataset.dec || '0', 10);
    var suffix = el.dataset.suffix || '';
    if (reduce) { el.textContent = fr(target, dec) + suffix; return; }
    var start = null, dur = 1400;
    function step(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fr(target * eased, dec) + suffix;
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    var nums = $$('[data-count-to]');
    var bars = $$('.hm-rev__track span[data-w]');
    if (!nums.length && !bars.length) return;
    var run = function (el) {
      if (el.dataset.w) { el.style.width = el.dataset.w + '%'; return; }
      el.dataset.to = el.dataset.countTo;
      animateNumber(el);
    };
    if (!('IntersectionObserver' in window)) { nums.concat(bars).forEach(run); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    nums.concat(bars).forEach(function (e) { io.observe(e); });
  }

  /* ==========================================================
     3. Compte à rebours "commande avant X"
     Cible : prochaine heure de coupure (jour ouvré).
     ========================================================== */
  function nextCutoff(hour) {
    var now = new Date();
    var c = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, 0, 0);
    if (now >= c) c.setDate(c.getDate() + 1);
    while (c.getDay() === 0 || c.getDay() === 6) c.setDate(c.getDate() + 1);
    return c;
  }

  function initCountdown() {
    var els = $$('[data-hm-countdown]');
    if (!els.length) return;
    els.forEach(function (el) {
      var hour = parseInt(el.dataset.glideCountdown, 10) || 15;
      var slots = {
        h: $('[data-cd-h]', el),
        m: $('[data-cd-m]', el),
        s: $('[data-cd-s]', el)
      };
      function tick() {
        var diff = nextCutoff(hour) - new Date();
        if (diff < 0) diff = 0;
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (slots.h) slots.h.textContent = pad(h);
        if (slots.m) slots.m.textContent = pad(m);
        if (slots.s) slots.s.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  /* ==========================================================
     5. Barre d'achat collante : implementation retiree le 2026-08-18.

     Elle faisait doublon avec celle de snippets/hm-sticky-atc.liquid et les
     deux se battaient sur le meme element : celle-ci basculait la classe
     `is-on` au-dela de 300px de defilement, l'autre basculait `is-visible`
     en observant le vrai bouton d'achat. Selon l'ordre de chargement la
     barre apparaissait ou non au bon moment.

     Son selecteur de variante etait mort par-dessus le marche : il cherchait
     `.hm-sticky__sel` et `[data-sticky-id]`, que le Liquid n'a jamais rendus.
     Le vrai select vit maintenant dans le snippet et pilote le selecteur de
     Dawn plutot qu'un champ cache parallele.
     ========================================================== */

  /* ==========================================================
     6. Pop-in email (délai + intention de sortie)
     ========================================================== */
  function initPopup() {
    var pop = $('[data-hm-pop]');
    if (!pop) return;
    /* `dataset.hmPop` et non `dataset.glidePop` : l'attribut rendu est
       `data-hm-pop`. Avec l'ancien nom la cle valait toujours `glide_pop_v1`
       et le reglage « Version », cense reafficher la pop-in a tout le monde,
       ne servait a rien. */
    var key = 'hm_pop_' + (pop.dataset.hmPop || 'v1');
    var days = parseInt(pop.dataset.days || '7', 10);
    var delay = parseInt(pop.dataset.delay || '18', 10) * 1000;

    try {
      var seen = localStorage.getItem(key);
      if (seen && Date.now() - parseInt(seen, 10) < days * 864e5) return;
    } catch (e) { /* stockage indisponible : on affiche quand même */ }

    var opened = false;
    /* La date est posee a L'OUVERTURE et non a la fermeture. Avec l'ancienne
       version, un visiteur qui ne fermait pas la pop-in mais cliquait un lien
       la retrouvait sur la page suivante, et sur toutes les suivantes : elle
       revenait toutes les 18 secondes en bloquant le defilement a chaque fois.
       Vue une fois, elle ne revient plus, quelle que soit la facon de s'en
       debarrasser. */
    function marquer() {
      try { localStorage.setItem(key, String(Date.now())); } catch (e) {}
    }
    function open() {
      if (opened) return;
      opened = true;
      marquer();
      pop.classList.add('is-on');
      document.body.style.overflow = 'hidden';
      var f = $('input[type="email"]', pop);
      if (f) setTimeout(function () { f.focus(); }, 350);
    }
    function close() {
      pop.classList.remove('is-on');
      document.body.style.overflow = '';
      marquer();
    }

    var timer = setTimeout(open, delay);
    function onLeave(e) {
      if (e.clientY <= 0) { clearTimeout(timer); open(); document.removeEventListener('mouseout', onLeave); }
    }
    if (window.matchMedia('(min-width: 750px)').matches) document.addEventListener('mouseout', onLeave);

    $$('[data-pop-close]', pop).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('is-on')) close(); });
    // succès Shopify : on mémorise pour ne plus réafficher
    if (pop.querySelector('.form-status, .form__message')) {
      try { localStorage.setItem(key, String(Date.now())); } catch (e) {}
    }
  }

  /* ==========================================================
     8. Preuve sociale légère : visiteurs sur la fiche
     Valeur stable sur une fenêtre de 20 min (pas de chiffre
     qui saute à chaque rechargement).
     ========================================================== */
  function initLive() {
    $$('[data-hm-live]').forEach(function (el) {
      var seed = 0, id = el.dataset.glideLive || '';
      for (var k = 0; k < id.length; k++) seed = (seed * 31 + id.charCodeAt(k)) % 9973;
      var slot = Math.floor(Date.now() / 12e5);
      var min = parseInt(el.dataset.min || '7', 10);
      var max = parseInt(el.dataset.max || '24', 10);
      var v = min + ((seed + slot * 17) % (max - min + 1));
      var out = $('[data-live-n]', el);
      if (out) out.textContent = v;
    });
  }

  /* ==========================================================
     9. Pack : ajout de plusieurs variantes en une fois
     ========================================================== */
  function initBundle() {
    $$('[data-hm-bundle]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = $('button[type="submit"]', form);
        var ids = form.dataset.glideBundle.split(',').filter(Boolean);
        if (!ids.length) return;
        var items = ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });

        var drawer = document.querySelector('cart-drawer');
        var body = { items: items };
        if (drawer && drawer.getSectionsToRender) {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
          body.sections_url = window.location.pathname;
        }

        if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Ajout en cours...'; }

        fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            var code = form.dataset.discount;
            if (code) { try { sessionStorage.setItem('glide_discount', code); } catch (e) {} }
            if (drawer && res.sections) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(res);
            } else {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
            }
          })
          .catch(function () { window.location = '/cart'; })
          .finally(function () {
            if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Ajouter le pack au panier'; }
          });
      });
    });
  }

  /* ==========================================================
     10. La pastille de franco s'efface devant le bouton de commande
     ========================================================== */
  /* Sur le panier, la pastille est fixée au bord gauche et le bouton de
     commande prend toute la largeur : dès qu'ils se croisent verticalement,
     la pastille couvre les 48 premiers pixels du bouton et avale le tap.
     C'est ce qui l'avait fait retirer du panier. Plutôt que de la cacher sur
     tout le gabarit, on la rétracte le temps que le bouton soit à l'écran :
     le rappel du franco reste visible pendant qu'on parcourt les lignes,
     et l'action principale n'est jamais recouverte. */
  function initShipBadgeDodge() {
    var pill = $('[data-hm-ship]');
    var cta = $('.cart__checkout-button');
    if (!pill || !cta || pill.dataset.dodgeBound) return;
    pill.dataset.dodgeBound = '1';

    if (!('IntersectionObserver' in window)) return;

    // Vrai test de recouvrement, et non « le bouton est-il visible ». La
    // premiere version se retirait des que le bouton entrait dans la fenetre :
    // en bas de la page panier, le bouton reste a l'ecran jusqu'au pied de
    // page, donc la pastille disparaissait pour de bon. Sur grand ecran le
    // bouton est aligne a droite et ne croise jamais la pastille, qui n'a donc
    // aucune raison de s'effacer.
    function overlaps() {
      var p = pill.getBoundingClientRect();
      var c = cta.getBoundingClientRect();
      // La pastille ne bouge plus : son rectangle est toujours le bon.
      return !(p.right < c.left || p.left > c.right || p.bottom < c.top || p.top > c.bottom);
    }

    var pending = false;
    function sync() {
      pending = false;
      pill.classList.toggle('hm-ship--dodge', overlaps());
    }
    function schedule() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(sync);
    }

    // L'observer sert de declencheur bon marche : il ne reveille le calcul que
    // quand le bouton approche, au lieu d'ecouter le defilement en continu.
    var io = new IntersectionObserver(schedule, {
      threshold: [0, 0.01, 1],
      rootMargin: '200px 0px 200px 0px'
    });
    io.observe(cta);

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    sync();
  }

  /* ==========================================================
     12. Panier : barre de commande fixe sur mobile
     ========================================================== */
  /* Elle n'apparaît que lorsque le bouton du flux est sorti de l'écran. Sur un
     panier court, il est visible dès le chargement et la barre ne se montre
     jamais ; sur un panier long, l'action reste toujours sous le pouce.

     Pas d'IntersectionObserver ici : `cart.js` de Dawn remplace le contenu de
     la section à chaque changement de quantité, donc le bouton observé serait
     détaché du document au premier « + » et l'observateur deviendrait muet. On
     re-interroge le DOM à chaque passage, ce qui survit aux re-rendus. */
  function initCartSticky() {
    if (document.body.dataset.hmStickyBound) return;
    if (!document.querySelector('[data-hm-sticky-checkout]')) return;
    document.body.dataset.hmStickyBound = '1';

    var pending = false;

    function sync() {
      pending = false;
      var bar = document.querySelector('[data-hm-sticky-checkout]');
      var cta = document.querySelector('.cart__checkout-button');
      if (!bar || !cta) return;

      var r = cta.getBoundingClientRect();
      /* « Atteignable » et non « visible » : on laisse 20px de tolérance pour
         ne pas faire clignoter la barre quand le bouton affleure le bord. */
      var reachable = r.top < window.innerHeight - 20 && r.bottom > 0;

      if (reachable) {
        bar.classList.remove('is-visible');
        /* `hidden` est reposé après la transition pour la sortir de l'ordre
           de tabulation, sans couper l'animation. */
        window.setTimeout(function () {
          if (!bar.classList.contains('is-visible')) bar.hidden = true;
        }, 260);
      } else {
        bar.hidden = false;
        /* Forcer un reflow avant d'ajouter la classe, sinon le passage de
           `hidden` à visible se fait d'un coup sans transition. */
        void bar.offsetHeight;
        bar.classList.add('is-visible');
      }
    }

    function schedule() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(sync);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('shopify:section:load', schedule);

    /* Après un changement de quantité, `cart.js` remplace le contenu de
       `.js-contents` : la barre est donc recréée avec son attribut `hidden`
       d'origine. Sans ce guetteur, elle resterait cachée jusqu'au prochain
       défilement. On resynchronise dès que le DOM du panier bouge. */
    var footer = document.getElementById('main-cart-footer');
    if (footer && window.MutationObserver) {
      new MutationObserver(schedule).observe(footer, { childList: true, subtree: true });
    }

    schedule();
  }

  /* ==========================================================
     13. Menu d'en-tête : ouverture au survol sur ordinateur
     ========================================================== */
  /* Dawn construit le menu avec <details>, donc le panneau n'existe pas dans
     le rendu tant que l'élément n'est pas ouvert : aucune règle CSS de survol
     ne peut le montrer, il faut poser l'attribut `open` en JavaScript.

     Le survol ne s'applique qu'aux pointeurs fins et aux grands écrans. Sur
     tactile, `hover` est simulé au premier tap et volerait le clic, donc le
     comportement d'origine est conservé tel quel.

     Deux détails qui comptent :
     - la fermeture est retardée, sinon la traversée du creux entre le libellé
       et le panneau (le rembourrage bas de l'en-tête) referme le menu ;
     - le clic sur un libellé ouvert ne referme plus, il suit le lien parent
       quand il en a un, ce que le survol rend attendu. */
  function initMenuHover() {
    var mq = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
    var DELAI_FERMETURE = 160;

    $$('.header__inline-menu header-menu').forEach(function (menu) {
      if (menu.dataset.hoverBound) return;
      menu.dataset.hoverBound = '1';

      var details = menu.querySelector('details');
      var summary = details && details.querySelector('summary');
      if (!details || !summary) return;
      var timer;

      function ouvrir() {
        window.clearTimeout(timer);
        if (!mq.matches || details.open) return;
        // Un seul panneau à la fois : le voisin encore ouvert sous son délai
        // de grâce se referme immédiatement.
        $$('.header__inline-menu details[open]').forEach(function (autre) {
          if (autre !== details) fermer(autre);
        });
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      }

      function fermer(cible) {
        var d = cible || details;
        d.removeAttribute('open');
        var s = d.querySelector('summary');
        if (s) s.setAttribute('aria-expanded', 'false');
      }

      function programmerFermeture() {
        if (!mq.matches) return;
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          if (menu.matches(':hover') || menu.contains(document.activeElement)) return;
          fermer();
        }, DELAI_FERMETURE);
      }

      menu.addEventListener('mouseenter', ouvrir);
      menu.addEventListener('mouseleave', programmerFermeture);

      summary.addEventListener('click', function (e) {
        if (!mq.matches) return;
        var href = summary.dataset.href;
        if (href && href !== '#') {
          e.preventDefault();
          window.location.href = href;
        } else if (details.open) {
          // Sans lien parent, le clic ne doit pas défaire ce que le survol a fait.
          e.preventDefault();
        }
      });
    });
  }

  /* ==========================================================
     14. Tiroir mobile : passage par-dessus les barres du haut
     ========================================================== */
  /* Le tiroir de Dawn démarre au bas de l'en-tête (`top:100%`) : la barre
     d'annonce et l'en-tête lui mangent le haut de l'écran et ses dernières
     entrées passent sous le pli. Il doit passer par-dessus, sans que rien ne
     bouge derrière : masquer la barre d'annonce le temps de l'ouverture avait
     été essayé et produisait un sursaut à chaque ouverture et fermeture.

     La remontée ne peut pas être écrite en dur : elle vaut la distance entre
     le haut de la fenêtre et le bas de l'en-tête, qui change avec la hauteur
     de la barre d'annonce (message sur une ou deux lignes) et avec l'en-tête
     collant. On la mesure à l'ouverture et on la publie en variable CSS. Sans
     JavaScript, le repli de la section 39 fait démarrer le tiroir au haut de
     l'en-tête, ce qui reste correct. */
  function initDrawerLift() {
    var cont = $('.menu-drawer-container');
    var wrapper = $('.header-wrapper');
    if (!cont || !wrapper || cont.dataset.liftBound) return;
    cont.dataset.liftBound = '1';

    var icone = cont.querySelector('summary');

    function sync() {
      var boite = wrapper.getBoundingClientRect();
      // Le tiroir démarre au HAUT DE L'EN-TÊTE, pas au haut de la fenêtre : il
      // couvre l'en-tête mais jamais la barre d'annonce. Sinon sa glissade de
      // fermeture masque le bandeau pendant trois dixièmes de seconde, ce que
      // l'oeil lit comme un bandeau qui disparaît puis revient.
      document.documentElement.style.setProperty('--hm-drawer-lift', Math.max(0, Math.round(boite.height)) + 'px');

      // La croix du tiroir doit tomber pile sur le hamburger qu'elle remplace,
      // qui passe sous le tiroir. On publie sa position plutôt que de la
      // deviner : elle dépend de la hauteur de la barre d'annonce, du logo et
      // du rembourrage de l'en-tête.
      var r = icone.getBoundingClientRect();
      var st = document.documentElement.style;
      // Coordonnées RELATIVES au tiroir, dont le coin haut gauche est
      // désormais celui de l'en-tête et non celui de la fenêtre.
      st.setProperty('--hm-drawer-close-top', Math.round(r.top + r.height / 2 - boite.top) + 'px');
      st.setProperty('--hm-drawer-close-left', Math.round(r.left + r.width / 2) + 'px');
    }

    cont.addEventListener('toggle', function () { if (cont.open) sync(); });
    window.addEventListener('resize', function () { if (cont.open) sync(); });
    sync();
  }

  /* La croix du tiroir rejoue le clic sur le résumé : c'est Dawn qui sait
     fermer proprement (classe `menu-opening`, piège de focus, défilement du
     corps rendu au document). */
  function initDrawerClose() {
    if (document.documentElement.dataset.drawerCloseBound) return;
    document.documentElement.dataset.drawerCloseBound = '1';
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-hm-drawer-close]')) return;
      var sommaire = $('.menu-drawer-container > summary');
      if (sommaire) sommaire.click();
    });
  }

  /* ==========================================================
     15. Article : sommaire ancré
     ========================================================== */
  /* Le sommaire est bâti ici plutôt qu'en Liquid : Liquid ne sait pas poser
     d'ancre dans un corps d'article déjà rendu, et on ne veut pas imposer à
     Comptoir d'écrire des `id` à la main dans son HTML.

     Rien ne s'affiche sous trois titres : sur un article court, un sommaire de
     deux lignes ne sert qu'à repousser le texte. */
  function initArticleToc() {
    var boite = $('[data-hm-toc]');
    var contenu = $('.article-template__content');
    if (!boite || !contenu || boite.dataset.tocBound) return;
    boite.dataset.tocBound = '1';

    var titres = $$('h2', contenu);
    if (titres.length < 3) return;

    var liste = boite.querySelector('ol');
    var vus = {};
    titres.forEach(function (titre) {
      if (!titre.id) {
        var base = (titre.textContent || '')
          .toLowerCase()
          .replace(/[^a-z0-9\s-]/g, '')
          .trim()
          .replace(/\s+/g, '-')
          .slice(0, 60) || 'section';
        vus[base] = (vus[base] || 0) + 1;
        titre.id = vus[base] > 1 ? base + '-' + vus[base] : base;
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + titre.id;
      a.textContent = titre.textContent.trim();
      li.appendChild(a);
      liste.appendChild(li);
    });

    boite.hidden = false;
  }

  /* ==========================================================
     16. Article : copie du lien de partage
     ========================================================== */
  function initShareCopy() {
    if (document.documentElement.dataset.shareCopyBound) return;
    document.documentElement.dataset.shareCopyBound = '1';
    document.addEventListener('click', function (e) {
      var bouton = e.target.closest('[data-hm-copy]');
      if (!bouton) return;
      var lien = bouton.dataset.hmCopy;
      function fait() {
        bouton.setAttribute('data-hm-copied', '1');
        window.setTimeout(function () { bouton.removeAttribute('data-hm-copied'); }, 1600);
      }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(lien).then(fait).catch(function () {});
      } else {
        var champ = document.createElement('textarea');
        champ.value = lien;
        champ.style.position = 'fixed';
        champ.style.opacity = '0';
        document.body.appendChild(champ);
        champ.select();
        try { document.execCommand('copy'); fait(); } catch (err) {}
        document.body.removeChild(champ);
      }
    });
  }

  /* ==========================================================
     11. Panier : ajout d'un exemplaire pour atteindre le palier
     ========================================================== */
  /* Le bloc est rendu par `snippets/hm-line-upsell.liquid`. On délègue
     l'écoute au document plutôt que de lier chaque bouton : `cart.js` de Dawn
     remplace le contenu des sections à chaque changement de quantité, donc
     tout écouteur posé sur un bouton disparaîtrait au premier rafraîchissement. */
  function initLineUpsell() {
    if (document.body.dataset.hmUpsellBound) return;
    document.body.dataset.hmUpsellBound = '1';

    /* `cart.js` de Dawn écoute TOUS les `change` qui remontent jusqu'à
       <cart-items> et les traite comme un changement de quantité. Sur un
       <select>, `event.target.step` vaut `undefined`, `inputValue % NaN` n'est
       jamais 0, et Dawn affichait « You can only add this item in increments
       of undefined » dans une bulle native du navigateur. On arrête donc la
       propagation avant qu'elle n'atteigne l'élément de Dawn. */
    document.addEventListener('change', function (event) {
      if (!event.target.closest('[data-hm-upsell]')) return;
      event.stopPropagation();
    }, true);

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-hm-upsell-add]');
      if (!btn) return;
      if (btn.disabled) return;

      var block = btn.closest('[data-hm-upsell]');
      var field = block && block.querySelector('[data-hm-upsell-variant]');
      var id = field && parseInt(field.value, 10);
      if (!id) return;

      var label = btn.textContent;
      btn.disabled = true;

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          /* Rechargement plutôt que rendu partiel : l'ajout peut faire basculer
             un palier, ce qui change le prix de TOUTES les lignes du produit,
             le bandeau de tête et le total. Recharger est le seul moyen sûr de
             ne rien laisser en arrière sur un panier remisé. */
          window.location.reload();
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = label;
        });
    });
  }

  /* ---- la piste du panier -----------------------------------
     cart-drawer.js remplace tout l'innerHTML de #CartDrawer à
     chaque mise à jour : l'élément est détruit puis recréé
     directement à sa valeur finale, donc aucune transition ne peut
     démarrer d'elle-même (c'est pour ça que l'ancienne barre
     sautait au lieu de glisser). On garde le dernier pourcentage
     hors du tiroir et on rejoue le trajet au remontage.

     Un custom element est le seul crochet qui survive à un
     innerHTML : un <script> inline inséré de cette façon ne
     s'exécute jamais. */
  var lastShipPct = null;

  if (window.customElements && !window.customElements.get('hm-shipbar')) {
    window.customElements.define(
      'hm-shipbar',
      class extends HTMLElement {
        connectedCallback() {
          var to = parseFloat(this.dataset.pct);
          if (isNaN(to)) return;

          var from = lastShipPct;
          lastShipPct = to;
          if (reduce || from === null || from === to) return;

          var el = this;
          /* Trois temps, et l'ordre compte : une transition se lit
             sur le style d'arrivée. Poser la valeur de départ et la
             transition dans le même recalcul ferait glisser la trace
             à l'envers, de la nouvelle valeur vers l'ancienne. */
          el.style.setProperty('--g-ship-pct', from);
          void el.offsetWidth;
          el.classList.add('is-gliding');
          void el.offsetWidth;
          requestAnimationFrame(function () {
            el.style.setProperty('--g-ship-pct', to);
          });
        }
      }
    );
  }

  /* ---------------------------------------------------------- */
  function boot() {
    initReveal();
    initCounters();
    initCountdown();
    initPopup();
    initLive();
    initBundle();
    initShipBadgeDodge();
    initLineUpsell();
    initCartSticky();
    initMenuHover();
    initDrawerLift();
    initDrawerClose();
    initArticleToc();
    initShareCopy();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // sections rechargées dans l'éditeur de thème
  document.addEventListener('shopify:section:load', boot);
})();
